export default{
    SESSION: {
        text: "SESSION",
        value: 1
    },

    SEMESTER: {
        text: "SEMESTER",
        value: 2
    }
}